import React, { Component } from 'react'
import './Profile.css'
import { Col, Image, Row } from 'react-bootstrap'
import "bootstrap/dist/css/bootstrap.min.css";

class Profile extends Component {
    render() {
        return (
            <Row>
                <Col md={4} xs={4}> <Image className="profileImg" src={process.env.PUBLIC_URL+"/IMG/profile-img.jpg"} roundedCircle />
                </Col>
                <Col md={8} xs={8} className="info"><h1 class="title">War Revend</h1>
                    <p class="desc">is a Software engineer with a B.Sc. in Computer Science and a M.Sc. in Applied Math from  KTH Royal Institute of Technology, Stockholm, Sweden. </p>
                </Col>
            </Row>
        )
    }
}
export default Profile;